export default "__VITE_ASSET__BTSSb1oC__"